export default theme => ({
  root: {

  },
  grid: {},
  menu: {},
  title: {
    marginLeft: theme.spacing(3),
    marginTop: theme.spacing(2),
  },
  brokerageSection: {
    margin: theme.spacing(3),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    '& > hr': {
      marginBottom: theme.spacing(2),
    },
  },
  brokerageSectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  field: {
    //padding: theme.spacing(3)
    margin: theme.spacing(3)
  },
  formControl: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    width: '100%',
    maxWidth: '100%',
    //marginRight: theme.spacing(3)
  },
  dropdownTopMargin: {
    marginTop: -theme.spacing(5)
  },
  dropdownTopMargin2Unit: {
    marginTop: -theme.spacing(2)
  },
  dropdownTopMargin1UnitPlus: {
    marginTop: theme.spacing(1)
  },
  fieldError: {
    color: theme.palette.error.main,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1)
  },
  brokerageField: {
    marginTop: -theme.spacing(1.5)
  },
  brokerageFieldTypo: {
    marginTop: theme.spacing(1)
  }
});
